import * as React from 'react'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid2 from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import { useDispatch, useSelector } from 'react-redux'
import { addNewParty, getAllParties } from '../../features/GeneralManagement/partiesInformationSlice'
import Navbar from '../../components/setup/Navbar'
import AutoComplete from '../../BuiltInComponent/AutoComplete'
import StickyHeadTable from '../../BuiltInComponent/TableWithPagination';
import HeadingText from '../../BuiltInComponent/HeadingTest'

export default function PartiesInformation() {

    const dispatch = useDispatch()
    const { parties, } = useSelector(state => state.partyInf)
    const [cateCode, setCateCode] = React.useState('')
    const [openingStatus, setOpeningStatus] = React.useState(false)

    const inputRef = React.useRef()

    React.useEffect(() => {
        dispatch(getAllParties())
    }, [dispatch])
    const handleSubmit = (event) => {
        event.preventDefault()

        const data = new FormData(event.currentTarget)
        const partyData = {
            PartyCategory: cateCode, PartyName: data.get('PartyName'),
            PartyUrduName: data.get('PartyUrduName'), email: data.get('email'), ContactNo: data.get('ContactNo'),
            AltContactNo: data.get('AltContactNo'), PartyAddress: data.get('PartyAddress'),
            PartyUrduAddress: data.get('PartyUrduAddress'), Debit: data.get('Debit'), Credit: data.get('Credit'),
            PartyStatus: true, OpenStatus: openingStatus, ContactPerson: data.get('ContactPerson'),
            NTN: data.get('NTN'), GST: data.get('GST')
        }
        dispatch(addNewParty(partyData))
        event.target.reset()
        inputRef.current.focus()
    };
    const PIFeilds = [
        { name: 'PartyName', label: 'Party Name', inputRef: inputRef }, { name: 'PartyUrduName', label: 'Party Urdu Name' },
        { name: 'email', label: 'Email' }, { name: 'ContactNo', label: 'Contact No' },
        { name: 'AltContactNo', label: 'Alternate Contact No' },
        { name: 'PartyAddress', label: 'Party Address' },
        { name: 'PartyUrduAddress', label: 'Party Urdu Address' },
        { name: 'ContactPerson', label: 'Contact Person' }, { name: 'NTN', label: 'N.T.N #' },
        { name: 'GST', label: 'G.S.T #' },
    ]
    const AccSection = [
        { name: 'Debit', label: 'Debit' },
        { name: 'Credit', label: 'Credit' }
    ]
    const onChangeCategory = (data) => {
        const keys = Object.keys(data)
        if (keys[0] === 'cateCode') {
            setCateCode(data[keys])
            console.log(data[keys])
            // dispatch(getSectionData({ sectionCode: data[keys] }))
        }
    }

    const tableColumns = [
        { fieldName: 'PartyCode', cName: 'Party Name', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'PartyName', cName: 'Party Name', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'PartyAddress', cName: 'Party Address', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'ContactPerson', cName: 'Contact Person', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'Debit', cName: 'Debit', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'Credit', cName: 'credit', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'right', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'right', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'right', width: 80, status: 'dis', dType: 'string' },
    ]

    const cateData = [{ cateCode: '01', cateName: 'SUPPLIERS' }]
    return (
        <>
            <Navbar />
            <Container>
                <Box component='form' noValidate onSubmit={handleSubmit}>
                    <HeadingText text='Parties Infromation' />
                    <Grid2 container spacing={2} sx={{ mt: 5 }}>
                        <Grid2 size={3}>
                            <AutoComplete
                                listData={cateData}
                                value={cateData.find((c) => c.cateCode === cateCode)}

                                onChange={onChangeCategory} />
                        </Grid2>
                        {PIFeilds.map((item) => (
                            <Grid2 size={3}>
                                <TextField
                                    autoComplete={item.name}
                                    name={item.name}
                                    required
                                    fullWidth
                                    id={item.name}
                                    label={item.label}
                                    inputRef={item.inputRef}
                                    size='small'
                                />
                            </Grid2>
                        ))}
                        <Grid2 size={3}>
                            <FormGroup>
                                <FormControlLabel control={<Checkbox onChange={() => setOpeningStatus(!openingStatus)} />} label="Select For Add Opening Balance" />
                            </FormGroup>
                        </Grid2>
                        {AccSection.map((item) => (
                            <Grid2 size={3}>
                                <TextField
                                    defaultValue={'0'}
                                    autoComplete={item.name}
                                    name={item.name}
                                    required
                                    type={item.type}
                                    fullWidth
                                    id={item.name}
                                    label={item.label}
                                    autoFocus
                                    disabled={!openingStatus}
                                    size='small'
                                />
                            </Grid2>
                        ))}
                        <Grid2 size={3} style={{ marginTop: -22 }}>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2, fontSize: 15 }}
                            >
                                ADD Party
                            </Button>
                        </Grid2>
                    </Grid2>
                </Box>
                <Grid2 container spacing={2}>
                    <Grid2 size={4}></Grid2>
                    <Grid2 size={4}>
                        <Typography style={{ textAlign: 'center', fontSize: 30, fontWeight: 'bolder', margin: 10, borderBottom: '5px double black', borderBottomStyle: 'double', textShadow: '3px 3px 3px grey' }}>Parties List</Typography>
                    </Grid2>
                    <Grid2 size={4}></Grid2>
                </Grid2>
                <StickyHeadTable tableColumns={tableColumns} tableData={parties && parties} />
                {/* <TableContainer component={Paper} sx={{ mb: 5 }}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ fontWeight: 'bolder', backgroundColor: '#1D4988', color: 'white' }}>Party Category</TableCell>
                                <TableCell align="left" style={{ fontWeight: 'bolder', backgroundColor: '#1D4988', color: 'white' }}>Party Name</TableCell>
                                <TableCell align="left" style={{ fontWeight: 'bolder', backgroundColor: '#1D4988', color: 'white' }}>Contact Person</TableCell>
                                <TableCell align="left" style={{ fontWeight: 'bolder', backgroundColor: '#1D4988', color: 'white' }}>Contact No</TableCell>
                                <TableCell align="left" style={{ fontWeight: 'bolder', backgroundColor: '#1D4988', color: 'white' }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {parties.map((row) => (
                                <TableRow
                                    key={row.name}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell align="left">{row.PartyCategory}</TableCell>
                                    <TableCell align="left">{row.PartyName}</TableCell>
                                    <TableCell align="left">{row.ContactPerson}</TableCell>
                                    <TableCell align="left">{row.ContactNo}</TableCell>
                                    <TableCell align="left"><Button
                                        onClick={() => {
                                            const deleteData = {
                                                userROle: user.user.role, userID: user.user.userID,
                                                deleteID: row.partyCateCode
                                            }
                                            // dispatch(deletePartyCategory(deleteData))
                                            setTimeout(() => {
                                                // dispatch(viewAllCategories(`${user.user.role}-${user.user.userID}`))
                                            }, 1000);
                                        }}
                                    >{<RestoreFromTrashIcon />}</Button></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer> */}
            </Container>
        </>
    )
}


